<template>
    <div>
        <AdminNavBar/>
        <router-view></router-view>
    </div>
</template>

<script>
    import AdminNavBar from "../../components/AdminNavBar";
    export default {
        name: "AdminLayout",
        components: {AdminNavBar}
    }
</script>

<style scoped>

</style>
